/* HUMANE — variant selection, size toggle, cart line updates. No dependencies. */
(function () {
  "use strict";

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var n = parts.join(".");
    if (!format) return "$" + n;
    return format.replace(/\{\{\s*\w+\s*\}\}/, n);
  }

  /* ---------- product form ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-variants]");
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price]");
    var addBtn = root.querySelector("[data-add]");
    var msgEl = root.querySelector("[data-msg]");
    var format = root.getAttribute("data-money-format") || "";
    var addLabel = addBtn ? addBtn.getAttribute("data-label-add") : "";
    var soldLabel = addBtn ? addBtn.getAttribute("data-label-sold") : "";

    function chosen() {
      var out = [];
      root.querySelectorAll("[data-option]").forEach(function (group) {
        var picked = group.querySelector("input:checked");
        out[+group.getAttribute("data-option")] = picked ? picked.value : null;
      });
      return out;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* gray out combinations that do not exist or are sold out */
    function paint(opts) {
      root.querySelectorAll("[data-option]").forEach(function (group) {
        var gi = +group.getAttribute("data-option");
        group.querySelectorAll("input").forEach(function (input) {
          var probe = opts.slice();
          probe[gi] = input.value;
          var v = match(probe);
          var wrap = input.parentNode;
          wrap.classList.toggle("is-on", input.checked);
          wrap.classList.toggle("is-off", !v || !v.available);
        });
      });
    }

    function showMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var slide = document.querySelector('.slide[data-media-id="' + variant.featured_media.id + '"]');
      if (!slide) return;
      var rail = slide.parentNode;
      var i = Array.prototype.indexOf.call(rail.children, slide);
      if (rail.goToSlide) rail.goToSlide(i);
    }

    function update(scroll) {
      var opts = chosen();
      var v = match(opts);
      paint(opts);

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldLabel; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = money(v.price, format);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += ' <span class="was">' + money(v.compare_at_price, format) + "</span>";
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : soldLabel;
      }
      root.querySelectorAll("[data-pill-for]").forEach(function (el) {
        var i = +el.getAttribute("data-pill-for");
        if (opts[i]) el.textContent = opts[i];
      });
      if (msgEl && scroll) msgEl.textContent = "";
      if (scroll) showMedia(v);

      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    }

    /* Bring a just-opened row fully into view, clear of the fixed nav bar,
       so the options are never half off the bottom of the screen. */
    function reveal(row) {
      var nav = document.querySelector(".bar");
      var navH = nav ? nav.offsetHeight : 0;
      var gap = 14;
      var rect = row.getBoundingClientRect();
      var below = rect.bottom + gap - (window.innerHeight - navH);
      var above = rect.top - gap;
      var move = below > 0 ? below : (above < 0 ? above : 0);
      if (!move) return;
      var soft = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollBy({ top: move, behavior: soft ? "smooth" : "auto" });
    }

    function setOpen(btn, row, open) {
      row.classList.toggle("collapsed", !open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    }

    root.addEventListener("change", function (e) {
      if (!e.target.matches("[data-option] input")) return;
      update(true);
      /* Picking a size closes the row again, so the page returns to fitting
         and the choice reads off the button. */
      var row = e.target.closest("[data-option]");
      var btn = row && root.querySelector('[data-toggle="' + row.getAttribute("data-option") + '"]');
      if (btn) setOpen(btn, row, false);
    });

    /* Size selector toggle, delegated so it works however the rows nest. */
    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-toggle]");
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var row = root.querySelector('[data-option="' + btn.getAttribute("data-toggle") + '"]');
      if (!row) return;
      var open = row.classList.contains("collapsed");
      setOpen(btn, row, open);
      if (open) window.requestAnimationFrame(function () { reveal(row); });
    });

    update(false);
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var rail = gallery.querySelector("[data-rail]");
    if (!rail) return;

    var slides = rail.children;
    var counter = gallery.querySelector("[data-counter]");
    var prev = gallery.querySelector("[data-prev]");
    var next = gallery.querySelector("[data-next]");
    var track = gallery.querySelector("[data-scrollbar]");
    var thumb = gallery.querySelector("[data-thumb]");
    var total = slides.length;
    var idle;

    function step() { return rail.clientWidth || 1; }
    function current() { return Math.round(rail.scrollLeft / step()); }
    function span() { return Math.max(rail.scrollWidth - rail.clientWidth, 1); }

    function paintBar() {
      if (!track || !thumb) return;
      var w = track.clientWidth;
      var ratio = Math.min(rail.clientWidth / (rail.scrollWidth || 1), 1);
      var tw = Math.max(w * ratio, 28);
      var pos = (rail.scrollLeft / span()) * (w - tw);
           var frac = Math.max(0, Math.min(rail.scrollLeft / span(), 1));
      thumb.style.setProperty("--tw", tw + "px");
      thumb.style.setProperty("--o", frac * 100 + "%");
      thumb.style.left = Math.max(0, Math.min(pos, w - tw)) + "px";
    }

    function paint() {
      var i = Math.min(Math.max(current(), 0), total - 1);
      if (counter) counter.textContent = i + 1 + " / " + total;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= span() - 2;
      paintBar();
    }

    /* exposed so the variant picker can jump to a colour's own image */
    rail.goToSlide = function (i) {
      var n = Math.min(Math.max(i, 0), total - 1);
      rail.scrollTo({ left: n * step(), behavior: "smooth" });
      window.setTimeout(paint, 60);
    };

    var liveTimer;
    function live() {
      if (!track) return;
      track.classList.add("is-live");
      window.clearTimeout(liveTimer);
      liveTimer = window.setTimeout(function () {
        track.classList.remove("is-live");
      }, 700);
    }

    rail.addEventListener("scroll", function () {
      paintBar();
      live();
      window.clearTimeout(idle);
      idle = window.setTimeout(paint, 60);
    }, { passive: true });

    if (prev) prev.addEventListener("click", function () { rail.goToSlide(current() - 1); });
    if (next) next.addEventListener("click", function () { rail.goToSlide(current() + 1); });

    rail.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); rail.goToSlide(current() + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); rail.goToSlide(current() - 1); }
    });

    if (track) {
      var dragging = false;

      function scrub(clientX) {
        var box = track.getBoundingClientRect();
        var tw = thumb ? thumb.offsetWidth : 28;
        var usable = Math.max(box.width - tw, 1);
        var at = (clientX - box.left - tw / 2) / usable;
        rail.scrollLeft = Math.max(0, Math.min(at, 1)) * span();
        paintBar();
      }

      track.addEventListener("pointerdown", function (e) {
        dragging = true;
        track.setPointerCapture(e.pointerId);
        rail.style.scrollBehavior = "auto";
        live();
        scrub(e.clientX);
      });
      track.addEventListener("pointermove", function (e) {
        if (dragging) scrub(e.clientX);
      });
      ["pointerup", "pointercancel"].forEach(function (evt) {
        track.addEventListener(evt, function () {
          dragging = false;
          rail.style.scrollBehavior = "";
          paint();
        });
      });
    }

    window.addEventListener("resize", function () {
      window.clearTimeout(idle);
      idle = window.setTimeout(paint, 120);
    });

    window.addEventListener("load", paint);
    paint();
  });

  /* ---------- size chart overlay ---------- */
  document.querySelectorAll("[data-chart]").forEach(function (chart) {
    var opener = document.querySelector("[data-chart-open]");
    var last;

    function open() {
      last = document.activeElement;
      chart.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
      var close = chart.querySelector("[data-chart-close]");
      if (close) close.focus();
    }
    function close() {
      chart.setAttribute("hidden", "");
      document.body.style.overflow = "";
      if (last) last.focus();
    }

    if (opener) opener.addEventListener("click", open);
    chart.addEventListener("click", function (e) {
      if (e.target === chart || e.target.closest("[data-chart-close]")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !chart.hasAttribute("hidden")) close();
    });
  });

  /* ---------- self-scrolling archive rails ---------- */
  /* Driven by transform rather than scrollLeft: scroll positions get rounded
     to whole pixels, which is what makes a slow marquee judder. A transform
     takes fractional values and stays on the compositor, so it runs smooth at
     any speed. */
  document.querySelectorAll("[data-auto]").forEach(function (rail) {
    var track = rail.querySelector(".rail-track");
    if (!track) return;

    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var back = rail.hasAttribute("data-reverse");
    var speed = parseFloat(rail.getAttribute("data-speed")) || 60;

    var offset = 0;
    var span = 0;
    var paused = false;
    var visible = true;
    var dragging = false;
    var dragFrom = 0;
    var dragAt = 0;
    var resume;
    var last = null;

    function firstStrip() { return track.querySelector(".strip"); }

    /* Clone strips until the loop is wider than the viewport, so a short set
       of images never leaves a gap at the wrap. */
    function fill() {
      var strip = firstStrip();
      if (!strip) return;
      var w = strip.offsetWidth;
      if (!w) return;
      var guard = 0;
      while (w * track.children.length < rail.clientWidth * 2 && guard < 12) {
        track.appendChild(strip.cloneNode(true));
        guard++;
      }
    }

    function measure() {
      var strip = firstStrip();
      span = strip ? strip.offsetWidth : 0;
      if (back && offset === 0) offset = span;
    }

    function draw() {
      track.style.transform = "translate3d(" + -offset + "px,0,0)";
    }

    function wrap() {
      if (span <= 0) return;
      while (offset >= span) offset -= span;
      while (offset < 0) offset += span;
    }

    function hold(ms) {
      paused = true;
      window.clearTimeout(resume);
      resume = window.setTimeout(function () { paused = false; }, ms || 1500);
    }

    function step(now) {
      if (last === null) last = now;
      var dt = Math.min((now - last) / 1000, 0.05);
      last = now;

      if (!still && !paused && !dragging && visible && span > 0) {
        offset += back ? -speed * dt : speed * dt;
        wrap();
        draw();
      }
      window.requestAnimationFrame(step);
    }

    /* Drag to move it yourself; it picks up again shortly after. */
    rail.addEventListener("pointerdown", function (e) {
      dragging = true;
      dragFrom = e.clientX;
      dragAt = offset;
      rail.setPointerCapture(e.pointerId);
      rail.classList.add("is-held");
    });
    rail.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      offset = dragAt - (e.clientX - dragFrom);
      wrap();
      draw();
    });
    ["pointerup", "pointercancel"].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove("is-held");
        hold(1500);
      });
    });
    rail.addEventListener("pointerenter", function () { if (!still) paused = true; });
    rail.addEventListener("pointerleave", function () { paused = false; });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { rootMargin: "150px" }).observe(rail);
    }

    function relayout() { fill(); measure(); wrap(); draw(); }

    rail.querySelectorAll("img").forEach(function (img) {
      if (!img.complete) img.addEventListener("load", relayout, { once: true });
    });
    window.addEventListener("resize", relayout);
    window.addEventListener("load", relayout);
    if (window.ResizeObserver) new ResizeObserver(relayout).observe(rail);

    relayout();
    window.requestAnimationFrame(step);
  });

  /* ---------- cart quantity ---------- */
  document.querySelectorAll("[data-cart-form]").forEach(function (form) {
    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-qty]")) form.submit();
    });
  });
})();
